import * as React from 'react';
import { fromArrayToString } from '../../../utils/from-array-to-string.js';
import '@grandvisionhq/graphql';
import '@swc/helpers';
import { useAppointmentContext } from '../context/AppointmentContext.js';
import { useRoutingContext } from '../context/RoutingContext/context.js';
import useBookAppointmentStore from './api/use-book-appointment-store.js';
import useVirtualAppointment from './use-virtual-appointment.js';

const useBookAppointmentStoreWithUrlParam = ()=>{
    const [, { queryParams  }] = useRoutingContext();
    const [getBookAppointmentStore, { called , data , loading , error  }] = useBookAppointmentStore();
    const [{ setStore  }, { store  }] = useAppointmentContext();
    const [{ getAppointmentTypeData , getStoreData  }, { storeCode: virtualStoreCode  }] = useVirtualAppointment();
    React.useEffect(()=>{
        if (error) {
            console.error(error);
            return;
        }
        const { storeId: storeIdFromUrl  } = queryParams;
        const storeId = fromArrayToString(storeIdFromUrl);
        if (loading || !storeId || storeId === `${store === null || store === void 0 ? void 0 : store.code}`) {
            return;
        }
        const isVirtualAppointmentStoreCode = Number(storeId) === virtualStoreCode;
        if (isVirtualAppointmentStoreCode) {
            setStore(getStoreData(undefined, getAppointmentTypeData()));
            return;
        }
        getBookAppointmentStore(Number(storeId));
    }, [
        queryParams,
        store,
        loading,
        error,
        virtualStoreCode,
        setStore,
        getStoreData,
        getAppointmentTypeData,
        getBookAppointmentStore, 
    ]);
    React.useEffect(()=>{
        if (!called || !data || loading) {
            return;
        }
        setStore(data);
    }, [
        called,
        data,
        loading,
        setStore
    ]);
};

export { useBookAppointmentStoreWithUrlParam as default };
//# sourceMappingURL=use-book-appointment-store-with-url-param.js.map
